<template>
<!-- 因为要进行统一登录这页面基本用不到 -->
  <div class="login" v-loading="loading" element-loading-text="登录中">
    <img class="logo" src="static/img/logo2022.png" />
    <div class="login-entrance">
      <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1" style="margin-left: 20%;">微信扫码登录/注册</el-menu-item>
        <el-menu-item index="2">统一认证登录</el-menu-item>
      </el-menu>
      <div class="program" v-if="activeIndex === '1'">
        <iframe
          height="300"
          width="450"
          id="wx"
          src="https://kid.ckcest.cn/authorize?response_type=code&client_id=testclient&state=1123&redirect_uri=https%3a%2f%2fcard.heidutech.com%2foauthtest.php"
          scrolling="no"
          frameborder="0"
        ></iframe>
        <!-- <p>微信扫描登录/注册</p> -->
      </div>
      <div class="login-link" v-if="activeIndex === '2'">
        <span>{{downTime}}秒后自动跳转到统一认证登录页面或者点击下方图片</span>
        <div class="Unified-login">
          <img src="static/img/logo2022.png" @click="goLogin()" />
          <p>中国工程科技知识中心统一身份认证</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store.js'
import { sendCode, getUser } from '@/api/login'
import { login } from '@/utils/index'
export default {
  name: 'login',
  data () {
    return {
      user: localStorage.getItem('user'),
      loading: false,
      activeIndex: '2',
      downTime: 10,
      timer: ''
    }
  },
  methods: {
    // 提交登录
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let formData = new FormData()
          formData.append('mobile', this.formData.mobile)
          formData.append('code', this.formData.code)
          window.location.href =
            'http://183.136.237.197/mobile_login?mobile=' +
            this.formData.mobile +
            '&code=' +
            this.formData.code
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 发送验证码
    sendCode () {
      let data = {
        mobile: this.formData.mobile,
        type: 2
      }
      sendCode(data)
        .then(res => {
          this.timeDown()
          this.$message(res.msg)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 倒计时
    timeDown () {
      let result = setInterval(() => {
        this.countdown--
        if (this.countdown < 0) {
          clearInterval(result)
          this.msg = '重新发送'
          this.countdown = 60
        }
      }, 1000)
    },

    // 选择扫码登录还是手机验证登录
    handleSelect (key) {
      this.activeIndex = key
      if (key === '2') {
        this.timer = setInterval(() => {
          this.downTime--
          if (this.downTime === 0) {
            clearInterval(this.timer)
            this.goLogin()
          }
        }, 1000)
      } else {
        this.downTime = 10
        clearInterval(this.timer)
      }
    },
    // 登录
    goLogin () {
      // window.location.href = 'http://183.136.237.197/login'
      login()
    }
  },
  store,
  mounted () {
    let tid = this.$route.query.tid
    if (!this.user) {
      if (!tid) {
        return
      }
      this.loading = true
      let data = {
        tid: tid,
        redirect_url: localStorage.getItem('redirect_url')
      }
      getUser(data)
        .then(res => {
          this.loading = false
          localStorage.setItem('user', JSON.stringify(res.data))
          // if(localStorage.getItem('redirect_url')){
          //   window.location.href = localStorage.getItem('redirect_url')
          //   localStorage.removeItem('redirect_url')
          //   return
          // }
          // if (localStorage.getItem('path')) {
          //   window.location.href = localStorage.getItem('path')
          //   localStorage.removeItem('path')
          // }else{
          //   this.$router.push({ path: '/' })
          // }
          this.$router.push({ path: '/' })
        })
        .catch(err => {
          console.log(err)
          this.goLogin()
        })
    } else {
      // if (this.$route.query.redicect === location.hostname) {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.push({ path: '/' })
      // }
      this.goLogin()
    }
  }
}
</script>

<style scoped>
.login {
  background: #eaeaea;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 40%;
}
.login-entrance {
  margin-top: 40px;
  padding-top: 20px;
  background: #fff;
  width: 450px;
  text-align: center;
}
.el-menu-item {
  width: 30%;
}
.login-link {
  text-align: center;
  height: 300px;
  padding: 30px;
}
.login-link span {
  font-size: 10px;
}
.Unified-login img {
  width: 400px;
  /* height: 207px; */
  margin: 50px 0;
  cursor: pointer;
}
.program {
  height: 300px;
  text-align: center;
}
.program p {
  margin-top: 5px;
  color: #999;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/Login.vue